module.exports = __webpack_public_path__ + "static/img/coe-heavy-horse-blue.9bcb8e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-heavy-horse-blue.svg
// module id = UEYE
// module chunks = 82